export default __webpack_public_path__ + "static/media/note.3c422677.png";